import { feature_activation_keys } from "features/FeatureActivation/FeatureActivationStatus.constants";
import useFeaturesActivationStatus from "features/FeatureActivation/utils/useFeaturesActivationStatus";

const useIsVdoCipherVideoHostingEnabled = () => {
  const { loading, featuresActivationStatus } = useFeaturesActivationStatus();
  const isVdoCipherEnabled =
    !featuresActivationStatus[
      feature_activation_keys.is_vdeocipher_disabled.key
    ];

  return { loading, isVdoCipherEnabled };
};

export default useIsVdoCipherVideoHostingEnabled;
